import { render } from "./Trash.vue?vue&type=template&id=3119a400"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"

import "./Trash.vue?vue&type=style&index=0&id=3119a400&lang=scss"
script.render = render

export default script